// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1M_Dz","alertIcon":"ConfirmModal_alertIcon__2Lzw9"};